<template lang="pug">
  div
    .form__title
      slot(name='title')
    form.form__body(action='javascript://', v-if='params')
      template(v-if="gameMode !== 'generator-settings'")
        .form__field
          label.form__label
            | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
          .form__field-body
            cs-multiselect(
              :multiple='false',
              :options='digitCapacityModes',
              :show-labels='false',
              :allow-empty='false',
              track-by='label',
              label='label',
              :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseDifficulty')",
              v-model='selectedDigitCapacity'
              @select="digitCapacityHandler"
            )
        .form__field
          label.form__label
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
          .form__field-body.form-container__select-examples
            cs-spin-input(
              :value="params.numOfExamples",
              :max="numOfExamples",
              :min="1",
              @increase="increaseExamples",
              @decrease="decreaseExamples",
              @input="params.numOfExamples = $event",
              :disabled="params && params.infinityAmountOfExamples"
            )
            .form-container__select-infinity-mode
              cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                v-model="params.infinityAmountOfExamples"
                :checked="params && params.infinityAmountOfExamples"
                :disabled="!!params.timeLimit"
              )
              svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
        .form__field
          label.form__label
            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
          .form__field-body
            cs-multiselect(
              :options="timeLimitValues",
              v-model="params.timeLimit"
              :placeholder="timeLimitLabel(params.timeLimit)"
              :multiple="false"
              :custom-label="timeLimitLabel"
              :hide-selected="false"
              :allow-empty="false"
            )
        .form__field
          label.form__label
            | {{ $i18n.t('trainer.trainer_gameFormSetting_coloredNumbers') }}
          .form__field-body
            cs-checkbox(
              v-model="params.coloredNumbers",
              :checked='params && params.coloredNumbers',
            )
        divider
      slot(name='parameters')
      slot(name='help')
      .form__buttons(v-if='!usersIds')
        cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
          | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
        template(v-if="gameMode === 'free-game'")
          cs-button.form__button(color="blue", @click='saveGameMode')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
        template(v-else='')
          cs-button.form__button(color="blue", @click='saveGame')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
      .form__buttons(v-else='')
        cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
          | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
        cs-button.form__button(color="blue", @click='saveGame')
          | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import IntervalConfig from '../../trainer/configs/IntervalConfig';

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                digitCapacityModes: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        value: 4,
                    },
                ],
                timeLimitValues: IntervalConfig.timeLimitValues,
                numOfExamples: 15,
                params: null,
                selectedDigitCapacity: null,
            };
        },
        watch: {
            'params.timeLimit': {
                handler(val) {
                    if (val) {
                        this.params.infinityAmountOfExamples = true;
                    }
                },
            },
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => {
                        return item.slug === this.slug && item.courseType === 'math-magic';
                    }).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedDigitCapacity = this.digitCapacityModes.find(
                digitCapacity => digitCapacity.value === this.params.digitCapacity
            );
        },
        methods: {
            digitCapacityHandler(digit) {
                this.selectedDigitCapacity = this.digitCapacityModes.find(
                    digitCapacity => digitCapacity.value === digit.value
                );
                this.params.digitCapacity = digit.value;
            },
            timeLimitLabel(amount) {
                return amount === 0
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
            decreaseExamples() {
                if (this.params.numOfExamples !== 1 && !this.params.infinityAmountOfExamples) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (this.params.numOfExamples !== this.numOfExamples && !this.params.infinityAmountOfExamples) {
                    this.params.numOfExamples += 1;
                }
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field--column {
        flex-direction: column;
        margin-bottom: 20px;
        align-items: flex-start;
    }

    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__label--left {
        min-width: 0;
        width: auto;
        margin-bottom: 20px;
    }

    .form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .form__field-body--bold {
        font-weight: 500;
    }

    .numbers-checkbox:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        width: 200px;
        margin: 20px 0 0 0;
        @include media($md) {
            margin: 0 0 0 20px;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox {
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
</style>
